
/************************************************************************************
	Estas funciones se encargan de establecer la conexión mediante webSocket con el 
    servicio encargado de definir el contenido que se va a visualizar y de enviar 
    al servidor la posición temporal del master referente a la reproducción del contenido. 
************************************************************************************/

export function setContent(cii, contentURL){

    var cs_ws = new WebSocket(cii.private[0].contentSetterUrl, 'echo-protocol');

    // Se envia el contenido que se quiere reproducir en la sala
    cs_ws.onopen = function() {
    
        var content = {
            contentId: contentURL, // url del mpd a reproducir
            custom: "custom"
        };
        console.log(contentURL);
        cs_ws.send(JSON.stringify(content));
        cs_ws.close();
    };
}

/**
 * Envia al servidor el estado actual del master en la reproducción del contenido:
 *     - Acción realizada (play, pause, seek, next)
 *     - Tiempo de reproducción en el que se ha realizado la acción
 *     - Número de pista en la que se ha posicionado (en caso de next)
 * @param {Object} cii Información de la sala
 * @param {String} action Acción realizada por el maestro
 * @param {Number} actionTime Tiempo de reproducción en el que se ha realizado la acción
 * @param {Number} [track] Número de pista en la que se ha posicionado (en caso de next)
 */
export function sendVC(cii, action, actionTime, track){

    var vc_ws = new WebSocket(cii.private[0].contentSetterUrl, 'echo-protocol');
    vc_ws.onopen = function(){

        var json = {
          action: action, // Acción realizada por el maestro
          actionTime: actionTime // Tiempo de reproducción en el que se ha realizado la acción
        };

        if (action == 'nextCamera'){
          json.cameraTrack = track;
        }

        if (action == 'nextAudio'){
            json.audioTrack = track;
        }

        if (action == 'cameraPosition'){
            json.cameraPosition = track;
        }

        if (action == 'volume'){
          json.volume = track;
        }

        vc_ws.send(JSON.stringify(json));
        vc_ws.close();

    };
}